import {
  IconArrowKeyDown,
  IconArrowKeyLeft,
  IconArrowKeyRight,
  IconArrowKeyUp
} from "../Icon/Icon.jsx";
import "./ShortcutReference.css";

function ShortcutIcon({ name }) {
  if (name === "up") {
    return <IconArrowKeyUp className="shortcut-key-icon" />;
  }

  if (name === "down") {
    return <IconArrowKeyDown className="shortcut-key-icon" />;
  }

  if (name === "left") {
    return <IconArrowKeyLeft className="shortcut-key-icon" />;
  }

  if (name === "right") {
    return <IconArrowKeyRight className="shortcut-key-icon" />;
  }

  return null;
}

function ShortcutKeys({ keys }) {
  return (
    <span class="shortcut-keys">
      {keys.map((key, index) => (
        key === "/" || key === "..."
          ? <span class="shortcut-separator" key={`${key}-${index}`}>{key}</span>
          : typeof key === "object" && key?.kind === "literal"
            ? <kbd class="shortcut-key" key={`${key.value}-${index}`}>{key.value}</kbd>
          : key === "+"
            ? null
          : typeof key === "object" && key?.kind === "icon"
            ? (
              <kbd class="shortcut-key" key={`${key.name}-${index}`}>
                <ShortcutIcon name={key.name} />
              </kbd>
            )
            : <kbd class="shortcut-key" key={`${key}-${index}`}>{key}</kbd>
      ))}
    </span>
  );
}

export function ShortcutReference({ groups, embedded = false }) {
  const content = (
    <div class={`shortcut-reference${embedded ? " shortcut-reference--embedded" : ""}`}>
      <div class="shortcut-reference-groups">
        {groups.map((group) => (
          <section class="shortcut-group" key={group.key}>
            <h3 class="shortcut-group-title">{group.label}</h3>

            <div class="shortcut-list">
              {group.shortcuts.map((shortcut) => (
                <div class="shortcut-row" key={shortcut.id}>
                  <div class="shortcut-copy">
                    <p class="shortcut-label">{shortcut.label}</p>
                    {shortcut.note ? <p class="shortcut-note">{shortcut.note}</p> : null}
                  </div>
                  <ShortcutKeys keys={shortcut.keys} />
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );

  if (embedded) {
    return content;
  }

  return (
    content
  );
}
